module.exports = __webpack_public_path__ + "img/invite.4b0b5e18.png";